/**
 * 관리자 목록 화면 sessionStorage 키 (상세 ↔ 목록 이동 시 상태 복원용)
 * 키는 util/listViewSessionPersistence.js 접두사와 조합되어 사용된다.
 */
export const LIST_VIEW_SESSION_KEYS = {
  students: 'students',
  managers: 'managers',
  groups: 'groups',
  courses: 'courses',
  assignments: 'assignments',
  trainings: 'trainings',
  projects: 'projects',
  library: 'library',
  faq: 'faq',
};
